<template>
  <div class="dimmed">
    <div class="timezone-wrap">
      <div class="content--header">
        <span class="header-icon">
          <i class="icon icon--timezone"></i>
        </span>
        <strong>{{ $t('timezone.dialog.title') }}</strong>
      </div>

      <div class="content--body">
        <div class="select__timezone--wrap">
          <label for="signUpTimezone">{{ $t('timezone.dialog.selectTitle') }}</label>

          <timezone-selectbox
            :width="370"
            :maxHeight="200"
            :placeholder="$t('timezone.dialog.selectPlaceholder')"
            :value="model.timezoneName"
            @change="onTimezoneChange"
          >
          </timezone-selectbox>
        </div>

        <div class="desc">
          <ul>
            <li><p v-html="$t('timezone.dialog.desc1', {domain: domain})"></p></li>
            <li><p class="highlight" v-html="$t('timezone.dialog.desc2')"></p></li>
          </ul>
        </div>

        <div class="agree">
          <ui-checkbox v-model="isAgree" :disabled="!model.timezoneName">
            <span class="terms-agree">
              {{ $t('timezone.dialog.check') }}
            </span>
          </ui-checkbox>
        </div>

        <div class="buttons">
          <ui-button class="btn__cancel" :buttonType="'reset'"  @click="$emit('closePopup')" v-if="isClose">
            {{ $t('common.cancel') }}
          </ui-button>
          <ui-button primary2 @click="onSubmit('check')" :disabled="!isSubmit">{{ $t('common.ok') }}</ui-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiCheckbox from '@/components/ui/UiCheckbox.vue'
import UiButton from '@/components/ui/UiButton.vue'
import TimezoneSelectbox from '@/components/ui/TimezoneSelectbox.vue'
import { updateTimezone } from '@/api/timezone'

export default {
  name: 'TimezoneSetting',
  components: { TimezoneSelectbox, UiButton, UiCheckbox },
  props: [
    'domain',
    'subDomain',
    'isClose',
    'type',
    'isCheck',
    'timezone',
    'timezoneName'
  ],
  created () {
    this.model.timezone = this.timezone
    this.model.timezoneName = this.timezoneName
  },
  data () {
    return {
      isAgree: false,
      model: {
        timezone: null,
        timezoneName: null
      },
      mainDomain: '',
      subDomains: []
    }
  },
  computed: {
    isSubmit () {
      return this.isAgree && this.model.timezone && this.model.timezoneName
    }
  },
  methods: {
    update () {
      const params = {
        domain: this.domain,
        timezone: this.model.timezone,
        timezoneName: this.model.timezoneName
      }
      updateTimezone(params).then(result => {
        this.$emit('confirm', this.model)
      })
    },
    async onSubmit () {
      if (this.isSubmit) {
        this.$emit('confirm', this.model)
      }
    },
    onTimezoneChange (value) {
      this.model = value
    }
  }
}
</script>

<style lang="scss">
.dimmed {
  & .timezone-wrap {
    width: 430px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    padding-top: 50px;
    padding-bottom: 25px;
    text-align: center;
    @include positionXYcenter;

    &.noEdit {
      .content--body {
        padding: 0 30px;
        margin-top: 25px;

        & .desc {
          font-size: 14px;
          line-height: 1.43;
          text-align: center;
          color: #2f2f2f;
          margin-bottom: 40px;
          & p {
            word-break: keep-all;
          }
        }
      }
    }

    & .content--header {
      & .header-icon {
        display:block;
      }
      & strong {
        padding-top: 12px;
        display: block;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.3;
        color: #444;
      }

    }

    .content--body {
      padding: 0px 20px 0 20px;

      & .info {
        width: 330px;
        border: solid 1px #d7d7d7;
        border-radius: 6px;
        background-color: #f4f4f4;
        padding: 20px;
        margin-bottom: 25px;
        font-size: 14px;
        line-height: 1.43;

        ul.main {

          & li {
            text-align: left;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0px;
            }
            & > .timezone-title {
              min-width: 100px;
              display: inline-block;
              overflow: hidden;
              color: #666;
              vertical-align: top;
            }

            & > .timezone-value {
              display: inline-block;
              color: #2f2f2f;
              width: calc(100% - 100px);
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
          }
        }
      }

      & .select__timezone--wrap {
        padding: 25px 10px 25px 10px;

        & label {
          display: block;
          text-align: left;
          font-size: 14px;
          font-weight: 500;
          color: #767676;
          padding-left: 5px;
          margin-bottom: 5px;
        }

        & .ui_select {
          width: 370px;
          & .selected-item {
            height: 38px;
          }

        }
      }

      & .desc {
        padding: 0 30px 0 45px;

        & ul {
          list-style: square;

          li {
            text-align: left;
            font-size: 14px;
            line-height: 1.43;
            color: #2f2f2f;
            padding-bottom: 12px;

            & .highlight {
              color: #ec0047;
            }
          }
        }
      }

      & .agree {
        padding: 25px 30px 40px 30px;
        text-align: left;

        .terms-agree {
          display: inline-block;
          position: relative;
          top: 1px;
          max-width: 302px;
          line-height: 1.43;
          font-weight: normal;
          font-family: Roboto;
        }

        .ui_checkbox {
          margin-left: 0px;

          & .icon {
            top: inherit;
            transform: inherit;
            margin-top: 2px;
          }
        }
      }

      & .buttons {
        & .btn__cancel {
          margin-right: 5px;
        }
      }
    }
  }
}

</style>
